const DISPLAY_TYPE = {
  PC: "PC",
  LAPTOP: "LAPTOP",
  MOBILE: "MOBILE"
}

export default { DISPLAY_TYPE }